
export const utilUrl = () => {

    const urlEntornoLocal = 'http://localhost:80';
    const urlEntornoLambda = 'https://cgmoazbtxd.execute-api.us-east-1.amazonaws.com/Stage/unadmin';
    const urlDominioServidor = 'http://54.87.215.166:80';

    const url = {
        1: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getScorts',
            urlDominioServidor
        },
        2: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getFilter',
            urlDominioServidor
        },
        3: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getReportScort',
            urlDominioServidor
        },
        4: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/eliminaUsuarioApp',
            urlDominioServidor
        },
        5: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getUsuariosApp',
            urlDominioServidor
        },
        6: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/cargarUsuarioApp',
            urlDominioServidor
        },
        7: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/actualizaPassScort',
            urlDominioServidor
        },
        8: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getScortFilterAdminZone',
            urlDominioServidor
        },
        9: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/actualizaPassScort',
            urlDominioServidor
        },
        10: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/eliminaScort',
            urlDominioServidor
        },
        11: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/actualizaAction',
            urlDominioServidor
        },
        12: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getScortZone',
            urlDominioServidor
        },
        13: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/actualizaPassApp',
            urlDominioServidor
        },
        14: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getLoginApp',
            urlDominioServidor
        },
        15: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getScortEdita',
            urlDominioServidor
        },
        16: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/cargarScort',
            urlDominioServidor
        },
        17: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getUrlPrefirmadas',
            urlDominioServidor
        },
        18: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getUrlImages',
            urlDominioServidor
        },
        19: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/uploadServiceScort',
            urlDominioServidor
        },
        20: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getServicesScort',
            urlDominioServidor
        },
        21: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/cargaCampaniaOferta',
            urlDominioServidor
        },
        22: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/dgc/service/getCampaniaOferta',
            urlDominioServidor
        },
    }

    return {
        apiLambda: true,
        url,
        urlEntorno: 'http://localhost:80'
    }
}

